export function hamburgerCategoryMenuView() {
  const hamburgerIcoBtnList = document.querySelectorAll('.js-headerAc');
  const hamburgerCategoryList = document.querySelectorAll('.js-hamburgerCategoryList');
  const IS_VIEW = 'is-view';
  const IS_MOUSEOVER = 'is-mouseover';

  hamburgerIcoBtnList.forEach((target) => {
    const targetData = target.dataset.menu;

    target.addEventListener('mouseover', () => {
      for (let i = 0; i < hamburgerIcoBtnList.length; i++) {
        hamburgerIcoBtnList[i].classList.remove(IS_MOUSEOVER);
      }
      for (let i = 0; i < hamburgerCategoryList.length; i++) {
        hamburgerCategoryList[i].classList.remove(IS_VIEW);
      }

      for (let i = 0; i < hamburgerCategoryList.length; i++) {
        const searchData = hamburgerCategoryList[i].dataset.menucategory;

        if (searchData == targetData) {
          hamburgerCategoryList[i].classList.add(IS_VIEW);
        }
      }
      target.classList.add(IS_MOUSEOVER);
    });
  });
}
